import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LineUpEditorPage } from './line-up-editor';

@NgModule({
  declarations: [
    LineUpEditorPage,
  ],
  imports: [
    IonicPageModule.forChild(LineUpEditorPage),
  ],
})
export class LineUpEditorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/line-up-editor/line-up-editor.module.ts